import "../order/order.css";
import { Card, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../components/header";
import image from "../../assets/image/home.webp";
import { handleError } from "../../helpers/handleError";
import { getMyEventDetailApi, initiateTicketTransferApi } from "../../api/api";
import { toast } from "react-toastify";
import AuthorizedQrImage from "../../components/qr/AuthorizedQrImage";

const TransferTickets = () => {
  const { eventid } = useParams();
  const token = useSelector((state) => state.auth.accessToken);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [toEmail, setToEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const nav = [
    { title: "Inicio", path: "/event" },
    { title: "Mis eventos", path: "/myevents" },
    { title: "Detalle", path: `/myevents/${eventid}` },
    { title: "Transferir", path: `/myevents/${eventid}/transfer` },
  ];

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const res = await getMyEventDetailApi(token, eventid);
      if (res.status === 200) setDetail(res.data.info);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && eventid) fetchDetail();
  }, [token, eventid]);

  const openTransfer = (ticket) => {
    setSelectedTicket(ticket);
    setToEmail("");
    setShowTransfer(true);
  };

  const submitTransfer = async () => {
    if (!selectedTicket?.id) return;
    const email = toEmail.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      try { toast.error("Ingresá un email válido"); } catch {}
      return;
    }
    try {
      setSubmitting(true);
      const res = await initiateTicketTransferApi(token, selectedTicket.id, email);
      const data = res?.data || {};
      if (data?.mode === "immediate") {
        try { toast.success("Transferencia realizada: el destinatario ya tenía cuenta."); } catch {}
      } else if (data?.mode === "pending") {
        try { toast.success("Enviamos un email con el link de reclamo."); } catch {}
      } else {
        try { toast.success("Solicitud de transferencia enviada."); } catch {}
      }
      setShowTransfer(false);
      fetchDetail();
    } catch (error) {
      handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Header imageSrc={image} title="Transferir tickets" navigation={nav} />
      <div className="pading150 order-container ">
        {!detail ? (
          <div className="cart-item-empty-container pading150">
            {loading ? (
              <span className="cart-empty-text">Cargando...</span>
            ) : (
              <span className="cart-empty-text">No se encontraron datos.</span>
            )}
          </div>
        ) : (
          <Card className="order-card mb-4">
            <Card.Body>
              <Card.Title className="order-title">Seleccioná la entrada a transferir</Card.Title>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                {(detail.tickets || []).map((t) => (
                  <div key={t.id} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 8, textAlign: 'center', width: 200 }}>
                    <AuthorizedQrImage src={t.qrUrl} accessToken={token} alt={`Ticket ${t.seq}`} width={160} height={160} style={{ display: 'block' }} />
                    <div className="order-date">Entrada {t.seq} • {t.status === 'redeemed' ? 'Usada' : 'Vigente'}</div>
                    <div style={{ marginTop: 8 }}>
                      <Button size="sm" variant="outline-primary" onClick={() => openTransfer(t)}>Transferir</Button>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 16 }}>
                <Button variant="secondary" onClick={() => navigate(`/myevents/${eventid}`)}>Volver</Button>
              </div>
            </Card.Body>
          </Card>
        )}
      </div>

      <Modal show={showTransfer} onHide={() => setShowTransfer(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Transferir ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Vas a transferir la entrada {selectedTicket?.seq}. Ingresá el email del destinatario:</p>
          <Form.Control
            type="email"
            placeholder="destinatario@dominio.com"
            value={toEmail}
            onChange={(e) => setToEmail(e.target.value)}
            disabled={submitting}
          />
          <div className="order-date" style={{ marginTop: 8 }}>
            Si no tiene cuenta, recibirá un correo con el link de reclamo.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTransfer(false)} disabled={submitting}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={submitTransfer} disabled={submitting}>
            {submitting ? "Enviando..." : "Enviar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransferTickets;
